import React from "react";
import { FiShield, FiTrendingUp, FiDatabase, FiShare2 } from "react-icons/fi";
import { LuSettings, LuUsers, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuClipboardList, LuCode, LuRocket } from "react-icons/lu";

// 1. Hero Block Configuration
export const saasDashboardHeroData = {
  backgroundImage: "/images/serviceBanners/saasDashboards.webp",
  whiteImage: "/images/serviceBanners/saasW.webp",
  subTitle: " Scalable SaaS Dashboard Design Systems",
  title: (
    <>
      Modern <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">SaaS Dashboard Design</span> Solutions
    </>
  ),
  description:
    "We design modern SaaS dashboards focused on real time data visualization, intuitive usability, and scalable architecture to help businesses simplify complex data, improve decision making, and enhance overall product efficiency.",
  primaryButton: {
    title: "Book SaaS Consultation",
    onClick: () => console.log("SaaS Consultation clicked"),
  },
  secondaryButton: {
    title: "View Dashboard Demos",
    onClick: () => console.log("Dashboard Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Data Visualization UI",
      desc: "Clear and intuitive dashboards for real-time business insights.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Scalable Dashboard Systems",
      desc: "Flexible UI structures built for growing SaaS products.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Performance-Focused Interfaces",
      desc: "Optimized layouts designed for speed and usability.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Secure & Modern UI Architecture",
      desc: "Reliable design systems focused on security and consistency.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/reactjs.svg",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(168,85,247,0.35)",
      iconGlow: "rgba(168,85,247,0.9)",
    },
  ],
};

// 2. Stats Block
export const saasStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Solutions & Process Block (WhyChooseUs Data)
export const saasSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE OPTIMIZE",
  buildTitle: "Custom SaaS Dashboard Design Solutions for Every Business Need",
  buildCards: [
    {
      title: "Cross-Platform UI Systems for SaaS Products",
      desc: "Build consistent experiences across web and mobile platforms.",
      icon: FiTrendingUp,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Enterprise SaaS Solutions",
      desc: "Develop scalable and secure systems for complex business needs.",
      icon: FiDatabase,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "E-Commerce Data Dashboards",
      desc: "Deliver real-time insights for better sales and customer tracking.",
      icon: FiTrendingUp,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "On-Demand Platform Systems",
      desc: "Design dashboards for booking, delivery, and service workflows.",
      icon: FiShare2,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "FinTech Dashboard Design",
      desc: "Create secure financial interfaces with advanced data visualization.",
      icon: FiShield,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Custom SaaS UI Systems",
      desc: "Build tailored dashboard systems aligned with product goals.",
      icon: FiDatabase,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "SaaS Dashboard Design & Development Approach",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Research",
      description: "Understand business goals, users, and data requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Strategy & Planning",
      description: "Define dashboard structure, KPIs, and user flow.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "Create clean and intuitive data-driven interfaces.",
      icon: LuCode,
    },
    {
      step: "04",
      title: "Development",
      description: "Build scalable and high-performance SaaS dashboard systems.",
      icon: LuRocket,
    },
    {
      step: "05",
      title: "Testing & Optimization",
      description: "Ensure usability, performance, and accurate data visualization.",
      icon: LuClipboardList,
    },
    {
      step: "06",
      title: "Deployment & Support",
      description: "Launch dashboards and provide continuous maintenance and improvements.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR SaaS DASHBOARD DESIGN SERVICES?",
  benefitsTitle: "Why Businesses Choose SaaS Dashboard Design Solutions",
  benefits: [
    "Consistent and scalable UI systems for SaaS dashboards",
    "Faster product design with reusable interface components",
    "Modern, clean, and data-driven user experience design",
    "Smooth performance with optimized UI architecture",
    "Efficient workflow using structured design systems",
    "Scalable solutions for growing SaaS products",
    "Cost-effective design systems that reduce development effort",
  ],
  logoImage: "/images/serviceBanners/saasDashboards.webp",
  whiteLogoImage: "/images/serviceBanners/saasW.webp",
};

// 4. Portfolio Data
export const saasPortfolioData = {
  subtitle: "OUR PROJECTS",
  title: "Dashboards Making Data Useful",
  buttonText: "View Interactive Demos",
  buttonLink: "#",
  apps: [
    {
      title: "Global BI Terminal",
      badge: "Analytics UI",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Real-time monitoring system handling millions of daily events via a custom high-density layout.",
      downloads: "Active",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
    },
  ],
};

// 5. Technologies Data
export const saasTechnologiesData = {
  techTitle: "OUR SaaS DESIGN STACK",
  technologies: [
    { name: "Figma", icon: "Palette" },
    { name: "React/Vue", icon: "ReactJS" },
    { name: "D3.js/Charts", icon: "RestAPI" },
    { name: "Tailwind CSS", icon: "Vite" },
    { name: "Storybook", icon: "Code" },
  ],
  trustTitle: "TRUSTED BY B2B ENTERPRISES",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon" },
  ],
};

// 6. About Overview
export const saasAboutData = [
  {
    title: "SaaS Dashboard Design Services for Smarter Business Decisions",
    content: (
      <>
        Modern software products rely on dashboards that simplify complex information and help users make faster decisions. Effective{" "}
        <b className="text-text-primary font-semibold">saas dashboard design services</b> focus on usability, clear navigation, and meaningful data presentation that improves the
        overall product experience. Businesses often struggle when dashboards feel cluttered or difficult to understand, which affects engagement and productivity. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, dashboard systems are designed around user behavior, business goals, and long-term scalability to
        create smoother digital experiences for SaaS products.
      </>
    ),
  },
  {
    title: "Web Application UI UX Design for Better Product Adoption",
    content: (
      <>
        A successful SaaS platform depends on how easily users can understand and interact with information. Reliable{" "}
        <b className="text-text-primary font-semibold">web application ui ux design</b> helps businesses create interfaces that reduce confusion and improve workflow efficiency.
        Companies investing in <b className="text-text-primary font-semibold">saas product design services</b> often experience stronger user engagement because digital products
        become easier to navigate and more intuitive to use. Tycho Technologies focuses on creating practical dashboard experiences that balance functionality, performance, and
        user expectations without unnecessary complexity.
      </>
    ),
  },
  {
    title: "Dashboard UI Design Company Focused on User Experience",
    content: (
      <>
        Strong dashboards do more than display information. A trusted <b className="text-text-primary font-semibold">dashboard ui design company</b> helps businesses create
        experiences that improve productivity, simplify reporting, and encourage better decision-making. Organizations aiming to improve product usability often combine dashboard
        planning with{" "}
        <a href="https://tychotechnologies.com/usability-testing-iteration-india" className="text-cyan-400 underline hover:text-cyan-300">
          usability testing services
        </a>{" "}
        to identify friction points and refine digital experiences before product scaling.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a SaaS UI UX Design Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">saas ui ux design company in india</b> continues to grow as businesses seek scalable digital
        products that improve customer experience and operational clarity. Companies investing in <b className="text-text-primary font-semibold">dashboard design services india</b>{" "}
        often prioritize clean interfaces, better usability, and long-term flexibility. Businesses working with Tycho Technologies gain access to tailored SaaS design frameworks
        built around real business needs. Many organizations also improve digital consistency by partnering with a reliable{" "}
        <a href="https://tychotechnologies.com/mobile-app-design-india" className="text-cyan-400 underline hover:text-cyan-300">
          mobile app design company in india
        </a>{" "}
        to strengthen user experiences across platforms.
      </>
    ),
  },
];

// 7. FAQs (Preserved & Relevant)
export const saasDashboardFaqs = [
  {
    q: "Why is specialized SaaS dashboard design necessary?",
    a: "SaaS dashboards often deal with high information density. Specialized design ensures users aren't overwhelmed, can find critical data quickly, and complete complex workflows without error.",
  },
  {
    q: "Do you design for multiple user roles (Admins, End-users, etc.)?",
    a: "Yes. Our multi-persona design approach ensures that each user level gets a tailored interface that highlights only the tools and data relevant to their specific role.",
  },
];
